import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestInStore({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'estoquespostoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteRecord({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `estoquespostoscomboios/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'estoquespostoscomboios', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/estoqueproduto');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `estoquespostoscomboios/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'estoquespostoscomboios', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/estoqueproduto');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'estoquespostoscomboios', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@estoqueproduto/STORE_IN_REQUEST', requestInStore),
  takeLatest('@estoqueproduto/DELETE', deleteRecord),
  takeLatest('@estoqueproduto/SUCCESS_REMOVE', requestInStore),
  takeLatest('@estoqueproduto/STORE', store),
  takeLatest('@estoqueproduto/FIND', find),
  takeLatest('@estoqueproduto/UPDATE', update),
  takeLatest('@estoqueproduto/RECORD_FILTERING', applyedFilters),
  takeLatest('@estoqueproduto/RESET_FILTERING', applyedFilters),
]);
